$(".desktop-grid-btn").click(function(){
    let selected_desktop_layout = $(this).attr("chosen-layout");
    setDesktopLayoutCookie("selectedDesktopGridLayout",selected_desktop_layout,1);
  });
  function setDesktopLayoutCookie(cookieGridName,gridLayoutValue,cExDays){
    const d = new Date();
    d.setTime(d.getTime()+(cExDays*24*60*60*1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cookieGridName + "=" + gridLayoutValue + ";" + expires + ";path=/";
  }
  function getDesktopLayoutCookie(cookieGridName){
    let language = cookieGridName + "=";
    let decodeCookie = decodeURIComponent(document.cookie);
    let ca = decodeCookie.split(";");
    for(let i=0;i < ca.length ; i++){
      let c = ca[i];
      while(c.charAt(0) == ' '){
        c = c.substring(1);
      }
      if(c.indexOf(language) == 0){
        return c.substring(language.length, c.length);
      }
    }
    return "";
  }
  function checkDesktopLayoutCookie(){
    let grid_style = getDesktopLayoutCookie("selectedDesktopGridLayout");
    if(grid_style != ""){
      $(".desktop-grid-btn").removeClass("actives");
      $("."+grid_style).addClass("actives");
      $("."+grid_style).trigger("click");
      if(grid_style =="fourtly"){
        $("#product-grid").addClass("grid--4-col-desktop").removeClass("grid--3-col-desktop");
      }
      if(grid_style =="thirtly"){
        $("#product-grid").addClass("grid--3-col-desktop").removeClass("grid--4-col-desktop");
      }
    }
  }
  window.addEventListener("DOMContentLoaded",function(){
    checkDesktopLayoutCookie();
  })